import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    apiKey: String
  }

  connect() {
    this.loadGoogleMaps()
  }

  async loadGoogleMaps() {
    if (window.google?.maps) {
      this.initMap()
      return
    }

    if (window._googleMapsLoading) {
      window._googleMapsLoading.then(() => this.initMap())
      return
    }

    window._googleMapsLoading = new Promise((resolve) => {
      window._googleMapsCallback = () => {
        delete window._googleMapsCallback
        resolve()
      }

      const script = document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}&callback=_googleMapsCallback`
      script.async = true
      document.head.appendChild(script)
    })

    window._googleMapsLoading.then(() => this.initMap())
  }

  initMap() {
    const position = { lat: this.latValue, lng: this.lngValue }

    const map = new google.maps.Map(this.element, {
      center: position,
      zoom: 14,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      gestureHandling: "cooperative",
      clickableIcons: false,
      minZoom: 5,
      maxZoom: 18
    })

    const marker = new google.maps.Marker({ map, position, cursor: "pointer" })

    marker.addListener("click", () => {
      window.open(`https://www.google.com/maps?q=${position.lat},${position.lng}`, "_blank")
    })
  }
}
